import { DYNAMIC_URLS } from 'consts';

export const generateFormUrl = (slug: string) =>
  `${window.location.origin}/v2${DYNAMIC_URLS.formExternal({
    formSlug: slug,
  })}`;

export const generateFormIframe = (slug: string) =>
  `<iframe src="${generateFormUrl(
    slug,
  )}" width="100%" height="500px"></iframe>`;
